import { call, delay, put, takeLatest, takeEvery, select } from 'redux-saga/effects'

import * as service from 'scripts/react-components/checkout/services/api/cart'
import { updateCartReference } from 'scripts/react-components/checkout/services/emitters'

import { dataLayer } from 'reactSite/Cart/services'

import { Actions, Constants, Selectors } from './'

function * getAssociatedProducts () {
  try {
    const data = yield call(service.getAssociateds)

    if (data) {
      yield put(Actions.updateAssociateds(data))
    }
  } catch (error) {
    yield put(Actions.getAssociatedsError(error?.data))
  }
}

function * addAssociatedToCart ({ id, regionId, updatePrice }) {
  try {
    yield put(Actions.startAddingProduct(id))

    const { data: { total, subTotal, discountTotal, shippings } } = yield call(service.putAssociatedProductsInCart, {
      regionId: null,
      type: 'delivery',
      products: [{ id, quantity: 1 }]
    })

    yield put(Actions.successAddingProduct(id))

    const type = shippings?.[0]?.type
    const ref = shippings?.[0].items?.[0]
    ref.fadeIn = true

    yield call(updateCartReference, { shippings })
    yield call(updatePrice, { price, subTotal, discountTotal, total })

    const {
      brand,
      categoryTree,
      name,
      price: { to_price: toPrice },
      shopName
    } = yield select(Selectors.getAssociatedProductById, id)

    const dataLayerObject = {
      brand,
      categoryTree,
      id,
      name,
      price: { to: toPrice },
      type,
      quantity: 1,
      shopName,
      regionId
    }

    yield call(dataLayer.addProduct, dataLayerObject)
  } catch (error) {
    yield put(Actions.errorAddingProduct(error?.data, id))
  }
}

function * timerToResetProductError () {
  yield delay(6000)
  yield put(Actions.resetPutProductError())
}

export default function * root () {
  yield takeLatest(Constants.ASSOCIATED_GET_PRODUCTS, getAssociatedProducts)

  yield takeLatest(Constants.ASSOCIATED_PUT_PRODUCTS_ERROR, timerToResetProductError)

  yield takeEvery(Constants.ASSOCIATED_PUT_PRODUCTS, addAssociatedToCart)
}
